import React from "react";
import { Container } from "react-bootstrap";
import "./TemplateHome.css";

const TemplateHome = ({ children }) => {
  return (
    <Container fluid className={`container__home pl-0 pr-0 overflow-hidden`}>
      <span className={`mt-5 `}>{children}</span>
    </Container>
  );
};

export default TemplateHome;
